import styled from "styled-components";

export const Container = styled.div`
  margin: 0 40px 0 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 1.5rem;
`;

export const TitleWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 15px;
  margin-bottom: 10px;
`;